"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsAuthorizedArray = getIsAuthorizedArray;
exports.getRedirectLocation = getRedirectLocation;
exports.getResponseHeaders = getResponseHeaders;
exports.getStatus = getStatus;
exports.isAnonymous = isAnonymous;
exports.isFloorplansDisabled = isFloorplansDisabled;
exports.isForcedSignOut = isForcedSignOut;
var _find = _interopRequireDefault(require("lodash/find"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function isAnonymous(routes, req) {
  if (!!routes && routes.length > 0) {
    // Return true if any route is anonymous
    return !!(0, _find.default)(routes, function (_ref) {
      var _route$props, _route$props2, _route$props3;
      var route = _ref.route;
      return (
        // Run isAnonymous function, or use boolean value
        (0, _isFunction.default)((_route$props = route.props) === null || _route$props === void 0 ? void 0 : _route$props.isAnonymous) ? (_route$props2 = route.props) === null || _route$props2 === void 0 ? void 0 : _route$props2.isAnonymous(route, req) : ((_route$props3 = route.props) === null || _route$props3 === void 0 ? void 0 : _route$props3.isAnonymous) === true
      );
    });
  }
  return false;
}
function isForcedSignOut(routes) {
  if (!!routes && routes.length > 0) {
    // Check if any route is forceSignOut
    return !!(0, _find.default)(routes, function (_ref2) {
      var _route$props4;
      var route = _ref2.route;
      return ((_route$props4 = route.props) === null || _route$props4 === void 0 ? void 0 : _route$props4.forceSignOut) === true;
    });
  }
  return false;
}
function isFloorplansDisabled(routes) {
  if (!!routes && routes.length > 0) {
    // Check if any route is disableFloorplans
    return !!(0, _find.default)(routes, function (_ref3) {
      var _route$props5;
      var route = _ref3.route;
      return ((_route$props5 = route.props) === null || _route$props5 === void 0 ? void 0 : _route$props5.disableFloorplans) === true;
    });
  }
  return false;
}
function getResponseHeaders(routes) {
  if (!!routes && routes.length > 0) {
    // Get array of response header objects
    var responseHeadersArray = routes.map(function (_ref4) {
      var _route$props6, _route$props7;
      var route = _ref4.route;
      return (0, _isFunction.default)((_route$props6 = route.props) === null || _route$props6 === void 0 ? void 0 : _route$props6.getResponseHeaders) && ((_route$props7 = route.props) === null || _route$props7 === void 0 ? void 0 : _route$props7.getResponseHeaders());
    });

    // Combine array of response headers into one object and add the sameorigin X-Frame-Options
    var responseHeaderObject = _objectSpread({
      'X-Frame-Options': 'sameorigin'
    }, responseHeadersArray.reduce(function (headers, current) {
      return _objectSpread(_objectSpread({}, headers), current);
    }));
    return responseHeaderObject;
  }
  return {};
}
function getRedirectLocation(routes) {
  var defaultRedirectLocation = {
    redirectPath: '',
    redirectSearch: ''
  };
  if (!!routes && routes.length > 0) {
    // Find first route that has a redirect
    var redirectRoute = (0, _find.default)(routes, function (_ref5) {
      var _route$props8;
      var route = _ref5.route;
      return !!((_route$props8 = route.props) !== null && _route$props8 !== void 0 && _route$props8.redirectLocation);
    });

    // If no redirect exists, return defaults
    if (!redirectRoute) {
      return defaultRedirectLocation;
    }

    // Accept both string or object for redirectLocation flag
    var redirectLocation = redirectRoute.route.props.redirectLocation;
    var redirectPath;
    var redirectSearch = '';
    if (typeof redirectLocation === 'string') {
      redirectPath = redirectLocation;
    } else {
      redirectPath = redirectLocation.pathName;
      redirectSearch = redirectLocation.search;
    }
    return {
      redirectPath: redirectPath,
      redirectSearch: redirectSearch
    };
  }
  return defaultRedirectLocation;
}
function getStatus(routes) {
  var statusCode;
  if (!!routes && routes.length > 0) {
    var _statusRoute$route;
    // Find first route that has a status
    var statusRoute = (0, _find.default)(routes, function (_ref6) {
      var _route$props9;
      var route = _ref6.route;
      return !!((_route$props9 = route.props) !== null && _route$props9 !== void 0 && _route$props9.status);
    });

    // If no status exists, return defaults
    statusCode = statusRoute === null || statusRoute === void 0 || (_statusRoute$route = statusRoute.route) === null || _statusRoute$route === void 0 || (_statusRoute$route = _statusRoute$route.props) === null || _statusRoute$route === void 0 ? void 0 : _statusRoute$route.status;
  }
  return statusCode;
}
function getIsAuthorizedArray(routes) {
  var isAuthorizedArray = [];
  routes && routes.forEach(function (_ref7) {
    var _route$props10;
    var route = _ref7.route;
    if ((_route$props10 = route.props) !== null && _route$props10 !== void 0 && _route$props10.isAuthorized) {
      var _route$props11;
      isAuthorizedArray.push((_route$props11 = route.props) === null || _route$props11 === void 0 ? void 0 : _route$props11.isAuthorized);
    }
  });
  return isAuthorizedArray;
}